
import { useEffect, useState } from "react";

import { Dialog, DialogTitle, IconButton, DialogContent, Grid, Typography, Tabs, Tab } from "@mui/material"

import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import { NotificacionArchivoProps } from "../interfaces/notificaciones/NotificacionesInterface";

interface Props{
    documento:           string;
    openDialog:          boolean;
    handleCloseDialog:   () => void;
    archivos?:           NotificacionArchivoProps[];
}

export const DialogDocumento = ({ documento, openDialog, handleCloseDialog, archivos } : Props ) => {

    const [fullScreen, setFullScreen] = useState( false );
    const [tab, setTab] = useState( 0 );

    useEffect(() => {

        if( openDialog ){
            setFullScreen( false );
            setTab( 0 );
        }

    }, [ openDialog ])

    const vistas = [
        { label: 'Razonamiento', contenido: documento },
        ...( archivos ?? [] ).map( ( archivo ) => ({ label: archivo.tipoArchivo || archivo.descripcion, contenido: archivo.contenido }) ),
    ];

    const vistaActual = vistas[ tab ] ?? vistas[0];

    return (
        <Dialog
            maxWidth="md"
            fullWidth={ true }
            open={ openDialog }
            fullScreen={ fullScreen }
            onClose={ () => {} }
        >

            <DialogTitle sx={{ backgroundColor: '#3c3c3c', p: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                {
                    ( archivos && archivos.length !== 0 )
                    ?
                        <Tabs
                            value={ tab }
                            onChange={ (_, value: number) => setTab( value ) }
                            variant='scrollable'
                            scrollButtons={ archivos.length > 4 }
                            allowScrollButtonsMobile
                            textColor='inherit'
                            sx={{
                                minHeight: 0,
                                '& .MuiTab-root': { color: 'rgba(255, 255, 255, 0.7)', minHeight: 0, py: 1.5 },
                                '& .Mui-selected': { color: 'white' },
                                '& .MuiTabs-indicator': { backgroundColor: 'white' },
                                '& .MuiTabs-scrollButtons': { color: 'white' },
                                '& .MuiTabs-scrollButtons.Mui-disabled': { opacity: 0.3 },
                            }}
                        >
                            {
                                vistas.map( ( vista, index ) => (
                                    <Tab key={ index } label={ vista.label } />
                                ))
                            }
                        </Tabs>
                    :
                        <span />
                }

                <span>

                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => setFullScreen( (prev) => !prev ) }>
                        { fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon /> }
                    </IconButton>

                    <IconButton size='small' sx={{ color: 'white' }} onClick={ handleCloseDialog }>
                        <CloseIcon />
                    </IconButton>

                </span>

            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>

                <Grid container spacing={3} height={'100%'} >

                    <Grid size={{ md: 12, xs: 12}} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>

                        {
                            vistaActual.contenido
                            ?
                                vistaActual.contenido.toString().slice(-3) === "pdf" || tab === 0
                                ?
                                    <iframe title={ vistaActual.label } src={ vistaActual.contenido } height={ fullScreen ? "100%" : '500px' } width="100%" style={{ border: 'none' }}></iframe>
                                :
                                    <img
                                        src={ vistaActual.contenido }
                                        alt={ vistaActual.label }
                                        style={{ maxWidth: '100%', maxHeight: fullScreen ? '100%' : '500px', objectFit: 'contain' }}
                                    />
                            :
                                <Typography variant='subtitle2' sx={{ fontSize: 18, fontWeight: 'bold', mt: 10, mb: 10 }}>
                                    No se encontró el documento
                                </Typography>
                        }

                    </Grid>

                </Grid>

            </DialogContent>

        </Dialog>
    )
}
